import { useParams } from 'react-router-dom';
import NotesSubjectView from '../../components/NotesSubjectView';
export default function AdminNotesSubject() { const { id } = useParams(); return <NotesSubjectView key={id} admin />; }
